import React, { Component } from "react";
import Select, { Creatable } from "react-select-plus";
import styled, { injectGlobal } from "styled-components";
import Icon from "modules/common/components/Icon";
import debounce from "lodash/debounce";
import { colors } from "modules/common/styles";
import PropTypes from "prop-types";
import { confirm } from "modules/common/utils";

injectGlobal`


  .Select.is-disabled .Select-control {
    cursor:not-allowed;

    .Select-value {
      cursor:not-allowed;

      .Select-value-label {
        cursor:not-allowed;
      }
    }
  }


`;
export const SelectValue = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -7px;
  padding-left: 25px;

  img {
    position: absolute;
    left: 0;
  }
`;

export const SelectOption = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Avatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: ${colors.bgActive};
  object-fit: cover;
  float: left;
  margin-right: 5px;
`;

const ClearButton = styled.div`
  position: absolute;
  right: 4px;
  font-size: 16px;
  top: 50%;
  width: 18px;
  z-index: 2;
  color: #999;
  line-height: 24px;
  margin-top: -12px;

  &:hover {
    color: #ea475d;
    cursor: pointer;
  }
`;

class SelectWithSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValues: props.initialValues,
      selectedOptions: props.selectedOptions,
      totalOptions: props.totalOptions,
    };
  }

  content(option) {
    return (
      <span>
        { option.avatar && <Avatar
          src={option.avatar}
        />}
        {option.label}
      </span>
    );
  }

  selectItemRenderer(option, showAvatar, OptionWrapper) {
    if (!showAvatar) {
      return option.label;
    }
    return <OptionWrapper>{this.content(option)}</OptionWrapper>;
  }

  renderClearButton = () => {
    if (!this.props.multi) {
      return null;
    }

    const { selectedValues = [] } = this.state;

    if (selectedValues.length > 0) {
      return (
        <ClearButton onClick={this.onClear}>
          <Icon icon="times" />
        </ClearButton>
      );
    }

    return null;
  };

  onClear = (e) => {
    confirm().then(() => {
      this.props.onSelect([], this.props.name);
      this.setState({ selectedValues: [], selectedOptions: [] });
    });
  };

  mergeSelect(totalOptions, initialValues) {
    let duplicate = {};
    let result = [];
    totalOptions = totalOptions || [];
    initialValues = initialValues || [];
    if (initialValues && initialValues.length !== 0) {
      initialValues.map((item) => {
        if (item && item.value) {
          duplicate[item.value] = true;
          result.push(item);
        }
      });
    }


    totalOptions.map((item) => {
      if (item.value && !duplicate[item.value]) {
        result.push(item);
      }
    });
    return result;
  }
  render() {
    const { __ } = this.context;
    const {
      loading,
      label,
      onSelect,
      addFilter,
      name,
      search,
      multi,
      customOption,
      showAvatar = true,
      disabled,
      totalOptions,
      initialValues,
      selectedValues,
      placeholder,
      isCreatable,
      tOptionRenderer,
      ...extraProp
    } = this.props;
    const selectMultiple = (ops) => {
      const selectedOptionsValues = ops.map((option) => option.value);

      onSelect(selectedOptionsValues, name, ops);

      this.setState(
        {
          selectedValues: selectedOptionsValues,
          selectedOptions: [...ops],
        },
        // () => onSearch("reload") // Here change for reload option on click of dropdown
      );
    };

    const selectSingle = (option) => {
      const selectedOptionValue = option ? option.value : null;
      const selectedOptionLable = option ? option.label : null;

      onSelect(selectedOptionValue, name, selectedOptionLable, option);

      this.setState({
        selectedValues: [selectedOptionValue],
        selectedOptions: [{ ...option }],
      });
    };

    const onChange = multi ? selectMultiple : selectSingle;

    const onSearch = (searchValue) => {
      if (searchValue) {
        debounce(() => search(searchValue), 1000)();
      }
    };

    const onOpen = () => search("reload");

    const selectOptions = this.mergeSelect(totalOptions, initialValues);

    if (customOption) {
      selectOptions.unshift(customOption);
    }

    let optionRenderer;
    let valueRenderer;

    if (multi) {
      valueRenderer = (option) =>
        this.selectItemRenderer(option, showAvatar, SelectValue);
    }
    const render = (option) => this.selectItemRenderer(option, showAvatar, SelectOption)
    optionRenderer = tOptionRenderer || render;
    if (isCreatable) {
      return (
        <Creatable
          placeholder={placeholder ? __(placeholder) : __(label)}
          value={multi ? selectedValues : selectedValues}
          loadingPlaceholder={__("Loading...")}
          isLoading={loading}
          onOpen={onOpen}
          onChange={onChange}
          optionRenderer={optionRenderer}
          valueRenderer={valueRenderer}
          onInputChange={onSearch}
          options={selectOptions}
          multi={multi}
          disabled={disabled}
          {...extraProp}
        />
      );
    } else {
      return (
        <Select
          placeholder={placeholder ? __(placeholder) : __(label)}
          value={multi ? selectedValues : selectedValues}
          loadingPlaceholder={__("Loading...")}
          isLoading={loading}
          onOpen={onOpen}
          onChange={onChange}
          optionRenderer={optionRenderer}
          valueRenderer={valueRenderer}
          onInputChange={onSearch}
          options={loading ? "" : selectOptions}
          multi={multi}
          disabled={disabled}
          {...extraProp}
        />
      );
    }
  }
}
SelectWithSearch.contextTypes = {
  __: PropTypes.func,
};
export default SelectWithSearch;



// WEBPACK FOOTER //
// src/modules/common/components/form/SelectWithSearch.js